<div *ngIf="lang == 'en'" class="d-flex w-100 justify-content-center container">
   <div class="row">
      <h4>TERMS AND CONDITIONS OF USE OF THE GOVERNMENTAL DELIVERY SERVICE (MDELIVERY)</h4>
      <h6 style="text-decoration: underline" class="w-100">1. Introduction</h6>
      <p class="justify-content-center ml-3">
         1.1. These Terms and Conditions (hereinafter - T&amp;C) shall apply to all the users of the Governmental
         Delivery Service (MDelivery)(hereinafter –MDelivery service).
      </p>
      <p class="justify-content-center ml-3">
         1.2. MDelivery service is the property of the Republic of Moldova and its owner and holder is the public
         institution „Moldovan e-Government Agency” (hereinafter – <em>MEGA)</em>.
      </p>
      <p class="justify-content-center ml-3">
         1.3. MDelivery servicewas established and operates in accordance with the provisions of the Government Decision
         no. /year regarding the approval of the Governmental Delivery service (MDelivery) Concept and the provisions of
         the Government Decision no. /year regarding the approval of the Regulation on the operation and use of the
         Governmental Delivery service (MDelivery).
      </p>
      <p class="justify-content-center ml-3">
         1.4. These T&amp;C are translated from Romanian into Russian and English languages. The translations are
         unofficial and are provided for convenience only. In the event of any discrepancy between the Romanian version
         and any foreign language translation, the Romanian version shall prevail.
      </p>
      <p class="justify-content-center ml-3">
         1.5. MDelivery service is an IT solution in the category Government to Citizen (G2C) and Government to Business
         (G2B) which is primarily aimed at providing the IT and information needs for the delivery process.
      </p>
      <h6 style="text-decoration: underline" class="w-100">2. Applicable Legislation</h6>
      <p class="justify-content-center ml-3"></p>
      <p class="justify-content-center ml-3">
         2.1. These T&amp;C have been developed in accordance with the Moldovan law.
      </p>
      <p class="justify-content-center ml-3">
         2.2. Any dispute arising in connection to these T&amp;C or to the use of MDelivery service (contractual or
         non-contractual) shall be submitted to the jurisdiction of the courts of the Republic of Moldova.
      </p>
      <h6 style="text-decoration: underline" class="w-100">3. Acceptance of T&amp;C</h6>
      <p class="justify-content-center ml-3">
         3.1. The User shall access and use MDelivery service only for the purposes permitted by legislation and within
         the frame of these T&amp;C.
      </p>
      <p class="justify-content-center ml-3">
         3.2. Some services provided in relation to the use of MDelivery servicemay have their own T&amp;C. Read them
         carefully before using such services.
      </p>
      <p class="justify-content-center ml-3">
         3.3. MDelivery serviceshall be used in a manner that will not infringe on, restrict or limit the rights of
         other users.
      </p>
      <h6 style="text-decoration: underline" class="w-100">4. Accessing MDelivery service</h6>
      <p class="justify-content-center ml-3">
         4.1. MDelivery servicecan be accessed with or without authentication. Authentication provides you access to
         MDelivery service according to the user type to which you belong.
      </p>
      <p class="justify-content-center ml-3">
         4.2. In case of authentication on the website dedicated to MDelivery service, the User is responsible for the
         security of any authentication-related information. Therefore, the User is responsible for all the activities
         that occur under the account.
      </p>
      <p class="justify-content-center ml-3">4.3. User accounts are not transferable to other persons.</p>
      <p class="justify-content-center ml-3">
         4.4. The User shall make sure that the information submitted for the creation of the account is up-to-date,
         complete, accurate and reliable. It is not recommended to use the authentication credentials to create other
         accounts.
      </p>
      <p class="justify-content-center ml-3">
         4.5. The User should not disclose the authentication credentials to any third parties and shall be solely
         responsible for all the consequences arising out of such disclosure.
      </p>
      <p class="justify-content-center ml-3">
         4.6. To access MDelivery service, it is recommended to use the latest three versions of the most popular
         browsers (Chrome, Edge, Safari, Firefox). The Product can be accessed both on desktop, and mobile devices
         (using iOS, Android or Windows operating systems).
      </p>
      <h6 style="text-decoration: underline" class="w-100">5. MDelivery s ervice Content</h6>
      <p class="justify-content-center ml-3"></p>
      <p class="justify-content-center ml-3">
         5.1. MDelivery service can store content that was not created and is not owned by MEGA. Such content is the
         responsibility of the person making it available. MEGA takes no responsibility for the conduct of third
         parties, including the persons the User communicates with using the informational services provided by the
         former.
      </p>
      <p class="justify-content-center ml-3">
         5.2. If MDelivery-associated services provide the possibility to upload, post or share content, the User shall
         be responsible for the content uploaded or shared via the informational system intended for the use of the
         Product. MEGA may remove or refuse to post content that violates the T&amp;C or the applicable legislation, but
         this does not mean that it monitors, analyses, or verifies all content. By accessing or using services
         associated to MDelivery, the User acknowledges and agrees that he/she may be exposed to offensive, indecent, or
         objectionable content.
      </p>
      <h6 style="text-decoration: underline" class="w-100">6. Use of MDelivery -Associated Services</h6>
      <p class="justify-content-center ml-3"></p>
      <p class="justify-content-center ml-3">
         6.1. The User confirms that he/she is allowed to use MDelivery-associated services under the law.
      </p>
      <p class="justify-content-center ml-3">
         6.2. If the User uses MDelivery-associated services on behalf of an individual or legal person, the former
         confirms that he/she has the legal authority to agree to these T&amp;C on behalf of the latter, meaning that
         the latter agrees to these T&amp;C.
      </p>
      <p class="justify-content-center ml-3">
         6.3. The User shall apply all guidelines or policies related to MDelivery-associated services.
      </p>
      <p class="justify-content-center ml-3">
         6.4. The User shall not misuse or interfere with MDelivery-associated services or try to access them by a
         method other than the interface and instructions made available by MEGA.
      </p>
      <p class="justify-content-center ml-3">
         6.5. Unless provided otherwise, the User shall not access or reuse MDelivery-associated services, or any other
         part of the informational system intended for the use of MDelivery service for commercial purposes.
      </p>
      <h6 style="text-decoration: underline" class="w-100">7. User’s Conduct</h6>
      <p class="justify-content-center ml-3"></p>
      <p class="justify-content-center ml-3">
         7.1. The User agrees not to interface with the servers or networks related to MDelivery-associated services and
         not to violate any MDelivery-related procedure, policy or rules, including:
      </p>
      <p class="justify-content-center ml-3">- pretend to be another person while using MDelivery service;</p>
      <p class="justify-content-center ml-3">
         - gain or attempt to gain unauthorized access to MDelivery services, servers, network or data;
      </p>
      <p class="justify-content-center ml-3">
         - upload content that is harmful to children, threatening, abusive, harassing, torturing, defamatory,
         slanderous, vulgar, obscene, invasive, inciting racial, ethnic or other hatred;
      </p>
      <p class="justify-content-center ml-3">
         - use MDelivery service for illegal purposes or in breach of the legislation;
      </p>
      <p class="justify-content-center ml-3">
         - make available any content for which it does not have permission or which affects any trademark, trade
         secret, copyright or other intellectual property of any person;
      </p>
      <p class="justify-content-center ml-3">
         - upload, post, send e-mail or any other material containing viruses or other computer codes, files or programs
         intended to interrupt, destroy or limit the functionality of MDelivery service or any other software or
         hardware or telecommunications equipment associated with the Product;
      </p>
      <p class="justify-content-center ml-3">
         - use MDelivery-associated services for the purpose of obtaining financial or similar benefits, unless it has
         the agreement of MEGA to do so.
      </p>
      <p class="justify-content-center ml-3"></p>
      <h6 style="text-decoration: underline" class="w-100">8. Notifications</h6>
      <p class="justify-content-center ml-3">
         8.1. MEGA may send notifications, including service announcements or notifications on changes in T&amp;C via
         e-mail, posts on the user access interface with the informational systems intended for MDelivery service use
         (dedicated webpages) or other existing reasonable methods which may be developed in the future. The User agrees
         to receive such notifications.
      </p>
      <h6 style="text-decoration: underline" class="w-100">9. Costs of Using the Product</h6>
      <p class="justify-content-center ml-3">
         9.1. Access to MDelivery service interface and its functionalities is free of charge, unless otherwise
         specified in the normative acts related to the MDelivery service;
      </p>
      <p class="justify-content-center ml-3">
         9.2. The costs of the delivery services are covered by the user of MDelivery service according to the costs set
         by the postal service provider.
      </p>
      <p class="justify-content-center ml-3">
         9.3. If the governmental electronic payment service (MPay) is used to pay for the services, the MPay T&amp;C,
         available at
         <a href="https://mpay.gov.md/Info/TermsAndConditions" target="_blank">
            https://mpay.gov.md/Info/TermsAndConditions</a
         >, shall apply.
      </p>
      <h6 style="text-decoration: underline" class="w-100">10. Product Availability</h6>
      <p class="justify-content-center ml-3"></p>
      <p class="justify-content-center ml-3">
         10.1. MDelivery service shall be available uninterruptedly 7 days a week. The guaranteed period for the agreed
         level of service availability is 24 hours a day. This time does not include the time allocated for the
         maintenance activities, which normally will be carried out outside the working hours, except for emergencies or
         under unforeseen circumstances.
      </p>
      <p class="justify-content-center ml-3">
         10.2. If MDelivery servicebecomes unavailable, please contact Customer Support.
      </p>
      <h6 style="text-decoration: underline" class="w-100">11. Disclaimer and Limitation of Liability</h6>
      <p class="justify-content-center ml-3"></p>
      <p class="justify-content-center ml-3">
         11.1. By using MDelivery service, the User understands and agrees that all the resources provided by MEGA are
         "as is" and "as available". This means that MEGA does not guarantee that:
      </p>
      <p class="justify-content-center ml-3">
         - the use of MDelivery service resources will meet all the needs or requirements of the User;
      </p>
      <p class="justify-content-center ml-3">
         - the use of the Product-associated services will be uninterrupted, timely, safe or error-free.
      </p>
      <p class="justify-content-center ml-3">
         11.2. MEGA shall not be liable for any damages, losses, costs (including legal costs), indirect expenses,
         losses or damages of any kind that may be suffered or borne by the payer in connection to the use of MDelivery
         service.
      </p>
      <h6 style="text-decoration: underline" class="w-100">12. Modification and Termination of Services and Account</h6>
      <p class="justify-content-center ml-3">
         12.1. MEGA constantly innovates, changes, and improves MDelivery-associated services. Thus, it is possible that
         without notifying the user, some functionalities or features may be added or removed, new service limits may be
         created, or the MDelivery-associated services may be suspended or ceased.
      </p>
      <p class="justify-content-center ml-3">
         12.2. The User may at any time stop using the MDelivery-associated services, cancel and/or delete the account.
      </p>
      <p class="justify-content-center ml-3">
         12.3. MEGA may temporarily suspend or cancel any account, without prior notice, in cases including, but not
         limited to, T&amp;C breach.
      </p>
      <h6 style="text-decoration: underline" class="w-100">13. Changes in T&amp;C</h6>
      <p class="justify-content-center ml-3"></p>
      <p class="justify-content-center ml-3">
         13.1. MEGA reserves the right to change these T&amp;C. Their updated version will be published on the users’
         access interface with the informational systems intended for the use of MDelivery service (dedicated webpages).
         It is the responsibility of the User to read the T&amp;C before using MDelivery service.
      </p>
      <h6 style="text-decoration: underline" class="w-100">14. Support and Assistance</h6>
      <p class="justify-content-center ml-3"></p>
      <p class="justify-content-center ml-3">
         14.1. For assistance, suggestions, or claims, please contact Customer Support via the following channels:
      </p>
      <p class="justify-content-center ml-3">Tel: (+373) (22) 82 00 00</p>
      <p class="justify-content-center ml-3">
         Email: <a href="mailto:suport.mdelivery@egov.md" target="_blank">suport.mdelivery@egov.md</a>
      </p>
      <p class="justify-content-center ml-3">
         14.2. For requests sent via email, the MDelivery service Support Team will make every effort to reply within 7
         business days. If you do not receive a reply within this period, our operators are most likely overloaded, so
         please get back to us with a new mail if your problem cannot wait and our team will re-prioritize your request.
      </p>
      <p class="justify-content-center ml-3">
         14.3. To receive support in case of a failure or problem, you are advised to:
      </p>
      <p class="justify-content-center ml-3">
         14.4. Notify the Product Management Team within 180 days of the incident/problem;
      </p>
      <p class="justify-content-center ml-3">
         14.5. Send all the documents subsequently requested by the MDelivery service Support Team.
      </p>
      <h6 style="text-decoration: underline" class="w-100">15. Feedback</h6>
      <p class="justify-content-center ml-3">
         15.1. The User agrees that any recommendation, idea, proposal, suggestion, or feedback (generically referred to
         as „Feedback”) sent to MEGA in relation to products, services, websites, applications or technologies may be
         used by MEGA without notice, obligation, restriction, compensation or reimbursement to the User and the User
         waives any right that he/she may have or might have in the future on any feedback.
      </p>
      <p class="justify-content-center ml-3"></p>
      <h6 style="text-decoration: underline" class="w-100">16. Confidentiality of Personal Data</h6>
      <p class="justify-content-center ml-3">
         16.1. MEGA is committed to put the User first and makes best efforts to ensure transparency in the collection,
         use and storage of personal data.
      </p>
      <p class="justify-content-center ml-3">
         16.2. Accessing the MDelivery service will be treated as a consent to process and store personal data, in
         accordance with the regulatory framework for personal data protection, for the purpose of formalizing a
         delivery order and may be challenged in the manner established by law.
      </p>
      <p class="justify-content-center ml-3">
         16.3. The user’s personal data includes all or one of the following categories: name/surname, e-mail, phone
         number, electronic signature, address, national identification number.
      </p>
      <p class="justify-content-center ml-3">
         16.4. Personal information is confidential and is not shared with third parties, including for purposes of
         marketing and revenue generation from the use of personal data, unless the owner of such data consents to it or
         it is requested by law-enforcement authorities under law.
      </p>
      <p class="justify-content-center ml-3">
         16.5. MEGA guarantees observance of the rights of the personal data owners provided by the regulatory framework
         on personal data protection and takes all measures to protect such data against unauthorized access, use or
         disclosure.
      </p>
      <p class="justify-content-center ml-3">
         16.6. The Product is registered at the National Center for Personal Data Protection with the registration
         number . MEGA is registered as personal data operator, which can be checked on the portal
         <a href="https://registru.datepersonale.md/" target="_blank">registru.datepersonale.md</a>.
      </p>
      <h6 style="text-decoration: underline" class="w-100">17. Intellectual Property Rights</h6>
      <p class="justify-content-center ml-3">
         17.1. The content and materials available in the MDelivery service and defined as text, images, graphics are
         provided as content licensed under CCBY 4.0
         <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank">
            (https://creativecommons.org/licenses/by/4.0/)</a
         >, unless clearly marked as copyrighted information.
      </p>
      <p class="justify-content-center ml-3">
         17.2. The website name, source code, trademark and logos are the intellectual property of MEGA and are
         protected by the applicable copyright and trademark legislation. Unless otherwise expressly authorized by MEGA,
         any inappropriate use, including, but not limited to their reproduction, distribution, display, or transmission
         is restricted, unless it is used by journalists and for MDelivery service promotion or academic purposes.
      </p>
      <p class="justify-content-center ml-3">
         17.3. MEGA respects the intellectual property rights of others and expects users to do the same. In appropriate
         circumstances and at its sole discretion MEGA may cancel or take other steps with respect to the user accounts
         which violates the intellectual property right. If you believe that your intellectual property right has been
         infringed, please contact Customer Support, and provide a written notice containing the following:
      </p>
      <p class="justify-content-center ml-3">
         - information about the copyrighted material alleged to have been infringed. If such material is available
         online, send the URL or provide relevant details to be identified;
      </p>
      <p class="justify-content-center ml-3">
         - contact details, including the name, address, telephone number and email, by which we can contact you;
      </p>
      <p class="justify-content-center ml-3">
         - a statement that the information in the written notice is accurate and that you are the right owner or
         authorized to act on behalf of the right owner, under the law;
      </p>
      <p class="justify-content-center ml-3">- your electronic or physical signature.</p>
      <h6 style="text-decoration: underline" class="w-100">18. Provider Data</h6>
      <p class="justify-content-center ml-3">
         <strong>
            Provider <br />
            Public Institution ”Moldovan eGovernance Agency ” <br />
            IDNO: 1010600034203 <br />
            Address: 42B Puskin str, Chisinau, MD-2012.
         </strong>
      </p>
      <p class="justify-content-center ml-3"></p>
   </div>
</div>
<div *ngIf="lang == 'ru'" class="d-flex w-100 justify-content-center container">
   <div class="row">
      <h4>ТЕРМИНЫ И УСЛОВИЯ ИСПОЛЬЗОВАНИЯ ПРАВИТЕЛЬСТВЕННОЙ УСЛУГИ ДОСТАВКИ (MDelivery)</h4>
      <h6 style="text-decoration: underline" class="w-100">1. Введение</h6>
      <p class="justify-content-center ml-3">
         1.1. Настоящие Термины и условия (далее – Т&amp;У) применяются ко всем пользователям Правительственной услуги
         доставки (MDelivery) (далее – услуга (MDelivery).
      </p>
      <p class="justify-content-center ml-3">
         1.2. Услуга (MDelivery) является собственностью Республики Молдова, её владельцем и держателем является
         Публичное учреждение «Агентство электронного управления» (далее – АЭУ).
      </p>
      <p class="justify-content-center ml-3">
         1.3. Услуга (MDelivery) была учреждена и действует на основе положений Постановления Правительства № - / год об
         утверждении Концепции государственной услуги доставки (MDelivery) и Постановление Правительства № - / год об
         утверждении Положения о порядке функционирования и использования правительственной услуги доставки (MDelivery).
      </p>
      <p class="justify-content-center ml-3">
         1.4. Эти Т&amp;У переведены с румынского языка на русский и английский языки. Эти переводы являются
         неофициальными и предоставляются только в качестве удобства, поэтому в случае расхождений между румынской
         версией и иностранными переводами преобладает версия на румынском языке.
      </p>
      <p class="justify-content-center ml-3">
         1.5. Услуга (MDelivery) - это ИТ-решение в категории «Правительство - гражданину» (G2C) и «Правительство -
         бизнесу» (G2B), основная цель котороой - обеспечение ИТ и информационных потребностей для процесса доставки.
      </p>
      <h6 style="text-decoration: underline" class="w-100">2. Применимая нормативная база</h6>
      <p class="justify-content-center ml-3">
         2.1. Эти Т&amp;У были разработаны в соответствии с положениями нормативной базы Республики Молдова.
      </p>
      <p class="justify-content-center ml-3">
         2.2. Любые споры, касающиеся этих Т&amp;У или использования услуги (MDelivery) (договорного или внедоговорного
         типа), подпадают под юрисдикцию судебных инстанций Республики Молдова.
      </p>
      <h6 style="text-decoration: underline" class="w-100">3. Принятие Т&amp;У</h6>
      <p class="justify-content-center ml-3">
         3.1. Пользователь обязуется осуществлять вход и использовать услугу (MDelivery) только в целях, разрешенных
         нормативной базой и в пределах описанных T&amp;У.
      </p>
      <p class="justify-content-center ml-3">
         3.2. Некоторые услуги, предлагаемые в рамках использовании услуги (MDelivery), могут иметь собственные
         применимые Т&amp;У – внимательно читайте эти Т&amp;У перед использованием соответствующих услуг.
      </p>
      <p class="justify-content-center ml-3">
         3.3. Пользователь будет использовать услугу (MDelivery) таким образом, чтобы не посягать, сокращать или
         ограничивать права других пользователей.
      </p>
      <h6 style="text-decoration: underline" class="w-100">4. Доступ к услуге (MDelivery)</h6>
      <p class="justify-content-center ml-3">
         4.1. Доступ к услуге (MDelivery) может быть осуществлен без аутентификации или с ней. Вход с аутентификацией
         обеспечивает доступ к услуге (MDelivery) в соответствии с категорией пользователей, к которой вы принадлежите.
      </p>
      <p class="justify-content-center ml-3">
         4.2. В случае аутентификации на веб-странице, посвященной услуге (MDelivery), пользователь несет
         ответственность за сохранение любой информации, связанной с аутентификацией. Следовательно, пользователь несет
         ответственность за все действия, происходящие в его учетной записи (аккаунте).
      </p>
      <p class="justify-content-center ml-3">4.3. Учетные записи пользователей не подлежат передаче другому лицу.</p>
      <p class="justify-content-center ml-3">
         4.4. Пользователь должен быть уверен, что информация, передаваемая для создания учетной записи, является
         актуальной, полной, точной и надежной. Рекомендуется не использовались аутентификационные данные для создания
         других учетных записей.
      </p>
      <p class="justify-content-center ml-3">
         4.5. Пользователю не рекомендуется передавать информацию об аутентификации третьему лицу. Любая такая передача
         является исключительной ответственностью пользователя, который берет на себя все связанные с этим последствия.
      </p>
      <p class="justify-content-center ml-3">
         4.6. Для доступа к услуге (MDelivery) рекомендуется использовать последние три версии наиболее популярных
         браузеров (Chrome, Edge, Safari, Firefox). К услуге (MDelivery) можно получить доступ как на настольных, так и
         на мобильных устройствах (с операционными системами iOS, Android, Windows).
      </p>
      <h6 style="text-decoration: underline" class="w-100">5. Контент услуги (MDelivery)</h6>
      <p class="justify-content-center ml-3"></p>
      <p class="justify-content-center ml-3">
         5.1. Услуга (MDelivery) может хранить контент, который не был создан AЭУ и которым оно не владеет. Этот контент
         является ответственностью лица, который делает его доступным. AЭУ не несет ответственности за поведение третьих
         лиц, в том числе лиц, с которыми пользователь общается с использованием предоставляемых ими информационных
         услуг.
      </p>
      <p class="justify-content-center ml-3">
         5.2. Услуги, связанные с услугой (MDelivery), могут предоставить возможность загружать, публиковать или
         передавать контент. В этом случае пользователь несет ответственность за контент, который он загрузил или
         передал через информационную систему, предназначенную для использования услуги (MDelivery). AЭУ может удалить
         или отказаться от публикации контента, нарушающего Т&amp;У или действующую нормативную базу, но это не
         означает, что оно осуществляет мониторинг, анализирует или проверяет любой контент. Получая доступ или
         используя услуги, связанные с услугой (MDelivery), пользователь признает и соглашается с тем, что он может
         столкнуться с оскорбительным, непристойным или неприятным контентом.
      </p>
      <h6 style="text-decoration: underline" class="w-100">6. Использование услуг, связанных с услугой (MDelivery)</h6>
      <p class="justify-content-center ml-3">
         6.1. Пользователь подтверждает, что ему разрешено пользоваться услугами, связанными с услугой (MDelivery), в
         соответствии с нормативной базой.
      </p>
      <p class="justify-content-center ml-3">
         6.2. Если пользователь обращается к услугам, связанным с услугой (MDelivery), от имени физического или
         юридического лица, он подтверждает, что у него есть законные полномочия для принятия этих Т&amp;У от имени
         этого лица, вследствие чего соответствующее физическое или юридическое лицо принимает эти Т&amp;У.
      </p>
      <p class="justify-content-center ml-3">
         6.3. Пользователь будет следовать любому руководству или политике, сопутствующей услугам, связанным с услугой
         (MDelivery).
      </p>
      <p class="justify-content-center ml-3">
         6.4. Пользователь не будет использовать услуги, связанные с услугой (MDelivery), неправомерным образом, и не
         будет интерферировать с услугами или пытаться получить доступ к ним посредством другого метода, кроме
         интерфейса и инструкций, предоставленных AЭУ.
      </p>
      <p class="justify-content-center ml-3">
         6.5. Если иное не предусмотрено, пользователь не будет осуществлять доступ или повторно использовать услуги,
         связанные с услугой (MDelivery), или любую часть информационной системы, предназначенной для использования
         продукта в коммерческих целях.
      </p>
      <h6 style="text-decoration: underline" class="w-100">7. Поведение пользователя</h6>
      <p class="justify-content-center ml-3">
         7.1. Пользователь соглашается не взаимодействовать с серверами или сетями, сопряженными с услугами, связанными
         с услугой (MDelivery), и не нарушать какие-либо процедуры, политику или правила, связанные с услугой
         (MDelivery), в том числе:
      </p>
      <p class="justify-content-center ml-3">- не выдавать себя за другое лицо при использовании услуги (MDelivery);</p>
      <p class="justify-content-center ml-3">
         - получить или пытаться получить неавторизированный доступ к услугам, серверам, сети или данным услуги
         (MDelivery);
      </p>
      <p class="justify-content-center ml-3">
         - не загружать контент, который является вредным для детей, угрожающим, неправомерным, оскорбительным,
         дискредитирующим, клеветническим, вульгарным, непристойным, агрессивным, разжигающим расовую, этническую или
         иную ненависть;
      </p>
      <p class="justify-content-center ml-3">
         - не использовать услугу (MDelivery) в незаконных целях или в нарушение нормативной базы;
      </p>
      <p class="justify-content-center ml-3">
         - не раскрывать любой контент, для которого нет соответствующего разрешения или который затрагивает какой-либо
         товарный знак, коммерческую тайну, авторское право или другой вид интеллектуальной собственности любого лица;
      </p>
      <p class="justify-content-center ml-3">
         - не загружать, не публиковать, не отправлять электронную почту или любой другой материал, содержащий вирусы
         или другие компьютерные коды, файлы или программы, предназначенные для прерывания, уничтожения или ограничения
         функциональности услуги (MDelivery) или любого другого программного или аппаратного обеспечения или
         телекоммуникационного оборудования, связанного с услугой (MDelivery);
      </p>
      <p class="justify-content-center ml-3">
         - не использовать услуги, связанные с услугой (MDelivery), с целью получения финансовых или аналогичных
         финансовым выгод, за исключением случаев, когда AЭУ дает на это согласие.
      </p>
      <h6 style="text-decoration: underline" class="w-100">8. Уведомления</h6>
      <p class="justify-content-center ml-3">
         8.1. AЭУ может отправлять уведомления, включая служебные объявления или уведомления об изменении Т&amp;У, через
         электронную почту, сообщения в интерфейсе доступа пользователей к информационным системам, предназначенным для
         использования услуги (MDelivery) (выделенные веб-страницы), или другими разумными текущими или которые могут
         быть разработаны в будущем методами. Пользователь соглашается получать такие уведомления.
      </p>
      <h6 style="text-decoration: underline" class="w-100">9. Стоимость использования услуги (MDelivery)</h6>
      <p class="justify-content-center ml-3">
         9.1. В настоящее время, если не указано иное в нормативных актах, связанные с услугой (MDelivery), доступ к
         интерфейсу услуги (MDelivery), и его функциональностям является бесплатным.
      </p>
      <p class="justify-content-center ml-3">
         9.2. Стоимость услуг доставки оплачивается пользователем услуги (MDelivery),в соответствии с стоимостью,
         установленной поставщиком почтовых услуг.
      </p>
      <p class="justify-content-center ml-3">
         9.3. В случае использования правительственной услуги электронных платежей (MPay) для оплаты некоторых услуг,
         применяются Т&amp;У услуги MPay, с которыми можно ознакомиться по адресу
         <a href="https://mpay.gov.md/Info/TermsAndConditions" target="_blank">
            https://mpay.gov.md/Info/TermsAndConditions</a
         >.
      </p>
      <h6 style="text-decoration: underline" class="w-100">10. Доступность услуги (MDelivery)</h6>
      <p class="justify-content-center ml-3">
         10.1. Услуга (MDelivery) доступна 7 дней в неделю с непрерывным графиком. Гарантированный период для
         согласованного уровня доступности услуг составляет 24 часа в сутки. Это время не включает период, отведенный
         для работ по техническому обслуживанию, которые обычно проводятся вне рабочего времени, за исключением случаев
         чрезвычайной ситуации или непредвиденных обстоятельств.
      </p>
      <p class="justify-content-center ml-3">
         10.2. Если услуга (MDelivery) недоступна, обратитесь в Службу поддержки клиентов.
      </p>
      <h6 style="text-decoration: underline" class="w-100">
         11. Отказ от ответственности и ограничение ответственности
      </h6>
      <p class="justify-content-center ml-3">
         11.1. Используя услугу (MDelivery) пользователь понимает и соглашается с тем, что все ресурсы, которые
         предоставляет AЭУ, являются «такими, какие они есть» и «такими, как они доступны». Это означает, что AЭУ не
         гарантирует, что:
      </p>
      <p class="justify-content-center ml-3">
         - использование ресурсов услуги (MDelivery) удовлетворит все потребности или требования пользователя;
      </p>
      <p class="justify-content-center ml-3">
         - использование услуг, связанных с услугой (MDelivery), будет бесперебойным, своевременным, безопасным или
         безошибочным.
      </p>
      <p class="justify-content-center ml-3">
         11.2. AЭУ не несет ответственности за ущерб, убытки, издержки (включая судебные издержки), косвенные расходы,
         ущерб или убытки любого рода, которые могут быть пережиты или понесены плательщиком от использования услуги
         (MDelivery).
      </p>
      <h6 style="text-decoration: underline" class="w-100">
         12. Изменение и прекращение предоставления услуг и учетной записи
      </h6>
      <p class="justify-content-center ml-3">
         12.1. AЭУ постоянно внедряет инновации, изменяет и улучшает услуги, связанные с услугой (MDelivery). Таким
         образом, возможно, без уведомления Пользователя, добавление или удаление некоторых функциональностей или
         характеристик, создание новых ограничений на услуги или приостановление или постоянное прекращение услуг,
         связанных с услугой (MDelivery).
      </p>
      <p class="justify-content-center ml-3">
         12.2. Пользователь в любой момент может прекратить использование услуг, связанных с услугой (MDelivery).
      </p>
      <p class="justify-content-center ml-3">
         12.3. AЭУ может временно приостановить или аннулировать любую учетную запись, без уведомления, в том числе, но
         не только, в случае нарушения T&amp;У или бездействия учетной записи.
      </p>
      <h6 style="text-decoration: underline" class="w-100">13. Изменения Т&amp;У</h6>
      <p class="justify-content-center ml-3">
         13.1. AЭУ оставляет за собой право изменять Т&amp;У, а обновленная версия будет опубликована в интерфейсе
         доступа пользователей к информационным системам, предназначенным для использования услуги (MDelivery)
         (выделенные веб-страницы). Ответственностью пользователя является чтение T&amp;У перед использованием услуги
         (MDelivery).
      </p>
      <h6 style="text-decoration: underline" class="w-100">14. Поддержка и помощь</h6>
      <p class="justify-content-center ml-3">
         14.1. Для получения помощи, предложений или подачи петиции обращайтесь в Службу поддержки клиентов по следующим
         каналам:
      </p>
      <p class="justify-content-center ml-3">Тел.: (+373) (22) 82 00 00;</p>
      <p class="justify-content-center ml-3">
         Email: <a href="mailto:suport.mdelivery@egov.md" target="_blank">suport.mdelivery@egov.md</a>.
      </p>
      <p class="justify-content-center ml-3">
         14.2. В случае запросов, отправленных по электронной почте, команда поддержки услуги (MDelivery) приложит все
         усилия, чтобы дать ответы в течение не более 7 рабочих дней. Если вы не получите ответ в течение этого срока,
         скорее всего, наши операторы перегружены, поэтому просим вас повторить сообщение, если ваш вопрос не терпит
         отсрочки, и наша команда приоритизирует ваш запрос.
      </p>
      <p class="justify-content-center ml-3">
         14.3. Для получения поддержки в случае возникновения неполадок или проблем, рекомендуем:
      </p>
      <p class="justify-content-center ml-3">
         14.4. Уведомление команды менеджмента услуги (MDelivery) в течение не более 180 дней после обнаружения
         инцидента/проблемы;
      </p>
      <p class="justify-content-center ml-3">
         14.5. Отправку всех актов/документов, впоследствии запрошенных командой поддержки услуги (MDelivery).
      </p>
      <h6 style="text-decoration: underline" class="w-100">15. Обратная связь (Feedback)</h6>
      <p class="justify-content-center ml-3">
         15.1. Пользователь соглашается с тем, что любая рекомендация, идея, предложение, совет или обратная связь
         (обычно называемая Feedback), переданная AЭУ со ссылкой на продукты, услуги, веб-сайты, приложения или
         технологии, может использоваться AЭУ без уведомления, обязательства, ограничения, компенсации или возмещения
         пользователю, и он отказывается от любого права, которое существует или может существовать в будущем в любом
         отзыве.
      </p>
      <h6 style="text-decoration: underline" class="w-100">16. Конфиденциальность персональных данных</h6>
      <p class="justify-content-center ml-3">
         16.1. АЭУ привержено тому, чтобы ставить на первое место пользователя. В связи с этим АЭУ прилагает все усилия
         для обеспечения прозрачности относительно способа корреляции и использования личной информации, а также
         относительно хранения этой информации.
      </p>
      <p class="justify-content-center ml-3">
         16.2. Доступ к услуги (MDelivery) будет рассматриваться как согласие на обработку и хранение личных данных в
         соответствии с нормативной базой для защиты личных данных с целью оформления заказа на доставку и может быть
         оспорено в порядке, установленном законом.
      </p>
      <p class="justify-content-center ml-3">
         16.3. Персональные данные пользователя включают все или одну из следующих категорий: имя / фамилия, электронная
         почта, телефон, электронная подпись, адрес, IDNP. Целью обработки информации, содержащей персональные данные,
         услугой (MDelivery) является административное управление процессом предоставления результатов государственных
         услуг и других результатов в рамках нормативной базы.
      </p>
      <p class="justify-content-center ml-3">
         16.4. Личная информация является конфиденциальной и не передается третьим лицам, в том числе ни в маркетинговых
         целях, ни в целях получения доходов от использования персональных данных, за исключением случаев, когда
         владелец таких данных дает на это согласие, или по запросу, в соответствии с нормативной базой, со стороны
         правоохранительных органов.
      </p>
      <p class="justify-content-center ml-3">
         16.5. АЭУ гарантирует соблюдение прав обладателей персональных данных, предусмотренной нормативной базой
         связанной с защитой персональных данных, принимая все меры для защиты этих данных от неавторизованного доступа,
         их использования или раскрытия.
      </p>
      <p class="justify-content-center ml-3">
         16.6. Услуга (MDelivery) зарегистрирована в Национальном центре по защите персональных данных с регистрационным
         номером __. AЭУ зарегистрировано в качестве оператора персональных данных, что можно проверить на портале
         <a href="https://registru.datepersonale.md" target="_blank"> registru.datepersonale.md</a>.
      </p>
      <h6 style="text-decoration: underline" class="w-100">17. Права интеллектуальной собственности</h6>
      <p class="justify-content-center ml-3">
         17.1. Содержимое и материалы, доступные в услуге (MDelivery), определяемые как текст, изображения, графика,
         предоставляются как контент под лицензией CCBY 4.0 (<a
            href="https://creativecommons.org/licenses/by/4.0/"
            target="_blank"
            >https://creativecommons.org/licenses/by/4.0/</a
         >) если явно не помечены как информация, защищенная авторскими правами.
      </p>
      <p class="justify-content-center ml-3">
         17.2. Название сайта, исходный код, товарные знаки и логотипы являются интеллектуальной собственностью AЭУ и
         защищены действующим законодательством об авторском праве и товарных знаках. Любое неадекватное использование,
         включая, помимо прочего, их воспроизведение, распространение, отображение или передачу, ограничено, если на это
         нет прямого разрешения АЭУ, за исключением случая, когда используется журналистами и в целях продвижения услуги
         (MDelivery) или в академических целях.
      </p>
      <p class="justify-content-center ml-3">
         17.3. AЭУ уважает права других лиц на интеллектуальную собственность и ожидает от пользователей аналогичного
         поведения. AЭУ может, в соответствующих обстоятельствах и по собственному усмотрению, отменить или предпринять
         другие шаги в отношении учетных записей пользователей, нарушающих право интеллектуальной собственности. Если вы
         считаете, что ваше право на интеллектуальную собственность нарушено, обратитесь в Службу поддержки клиентов и
         отправьте уведомление со следующей информацией:
      </p>
      <p class="justify-content-center ml-3">
         - информацией о материале, на которое, по вашему мнению, было нарушено право интеллектуальной собственности.
         Если этот материал существует в Интернете, вы передаете URL-адрес или предоставляете соответствующие детали для
         идентификации;
      </p>
      <p class="justify-content-center ml-3">
         - контактной информацией, включая ФИО, адрес, номер телефона и адрес электронной почты, по которому мы можем с
         вами связаться;
      </p>
      <p class="justify-content-center ml-3">
         - подтверждением от вас, что передаваемая информация достоверна и что в соответствии с нормативными рамками вы
         являетесь правообладателем или уполномочены представлять интересы обладателя соответствующих прав;
      </p>
      <p class="justify-content-center ml-3">- вашей электронной или физической подписью.</p>
      <h6 style="text-decoration: underline" class="w-100">18. Данные Поставщика</h6>
      <p class="justify-content-center ml-3">
         <strong>
            Поставщик <br />
            Публичное учреждение «Агентство электронного управления» <br />
            IDNO: 1010600034203 <br />
            Адрес: мун. Кишинэу, ул. Пушкина, 42 «B», MD-2012.
         </strong>
      </p>
   </div>
</div>
<div *ngIf="lang == 'ro'" class="d-flex w-100 justify-content-center container">
   <div class="row">
      <h4>TERMENI ȘI CONDIȚII DE UTILIZARE A SERVICIULUI GUVERNAMENTAL DE LIVRARE (MDELIVERY)</h4>
      <h6 style="text-decoration: underline" class="w-100">1. Introducere</h6>
      <p class="justify-content-center ml-3">
         1.1. Acești Termeni și Condiții (&icirc;n continuare &ndash; <em>T&amp;C</em>) se aplică tuturor utilizatorilor
         Serviciului guvernamental de livrare (MDelivery) (&icirc;n continuare &ndash; <em>serviciul MDelivery</em>).
      </p>
      <p class="justify-content-center ml-3">
         1.2. Serviciul MDelivery este proprietate a Republicii Moldova, posesor și deținător al acestuia este
         Instituția Publică &bdquo;Agenția de Guvernare Electronică&rdquo; (&icirc;n continuare &ndash; <em>AGE</em>).
      </p>

      <p class="justify-content-center ml-3">
         1.3. Acești T&C sunt traduși din limba română în limba rusă și limba engleză. Aceste traduceri sunt neoficiale
         și sunt furnizate doar ca traduceri de conveniență, astfel încât în eventualitatea unor discrepanțe între
         versiunea în limba română și traducerile străine prevalează versiunea în limba română.
      </p>

      <p class="justify-content-center ml-3">
         1.4. Serviciul MDelivery reprezintă o soluție informatică din categoria Guvern către Cetățean (G2C) și Guvern
         către Business (G2B) care are drept obiectiv principal asigurarea necesităților informatice și informaționale
         pentru realizarea procesului de livrare.
      </p>

      <p class="justify-content-center ml-3">
         1.5. În sensul T&C descriși, se utilizează următoarele noțiuni: <em>comandă de livrare</em> – cerere de
         solicitare a livrării rezultatului prestării serviciului public; <em>utilizator (destinatar)</em> - persoană
         fizică sau juridică de drept privat care recepționează fizic de la expeditor, prin intermediul furnizorului de
         servicii poștale, trimiteri poștale ce conțin rezultate ale prestării serviciilor publice; <em>expeditor</em> –
         persoană fizică sau juridică de drept public sau de drept privat care expediază o trimitere poștală prin
         intermediul serviciului MDelivery; <em>furnizor de servicii poștale</em> – persoană fizică sau juridică,
         înregistrată în calitate de întreprinzător, care furnizează unul sau mai multe servicii poștale, precum și alte
         servicii conexe acestora; <em>trimitere poștală</em> - bun având înscrisă o adresă la care urmează să fie
         distribuit de furnizorul de servicii poştale. <em>document de însoțire</em> - document generat de sistemul
         informațional al serviciului MDelivery, care însoțește obligatoriu rezultatul prestării serviciului public
         remis pentru livrare în cadrul serviciului MDelivery, pentru identificarea unică și urmărirea acestuia.
      </p>

      <h6 style="text-decoration: underline" class="w-100">2. Cadrul normativ aplicabil</h6>
      <p class="justify-content-center ml-3">
         2.1. Acești T&amp;C au fost elaborați &icirc;n conformitate cu prevederile cadrului normativ al Republicii
         Moldova.
      </p>
      <p class="justify-content-center ml-3">
         2.2. Serviciul MDelivery a fost instituit și operează în baza prevederilor Hotărârii Guvernului nr.152/2021 cu
         privire la aprobarea Conceptului serviciului guvernamental de livrare (MDelivery) și prevederilor Hotărârii
         Guvernului nr.180/2022 cu privire la aprobarea Regulamentului privind modul de funcționare și utilizare a
         serviciului guvernamental de livrare (MDelivery).
      </p>

      <p class="justify-content-center ml-3">
         2.3. Orice dispute referitoare la acești T&C sau de utilizare a serviciului MDelivery (de tip contractual sau
         non-contractual) sunt supuse jurisdicției instanțelor de judecată ale Republicii Moldova.
      </p>

      <h6 style="text-decoration: underline" class="w-100">3. Acceptarea T&amp;C</h6>
      <p class="justify-content-center ml-3">
         3.1. Utilizatorul se obligă să acceseze și să utilizeze serviciul MDelivery doar &icirc;n scopurile permise de
         cadrul normativ și &icirc;n limita T&amp;C descriși.
      </p>

      <p class="justify-content-center ml-3">
         3.2. Unele servicii oferite &icirc;n cadrul utilizării serviciului MDelivery pot avea proprii T&amp;C, care se
         pot aplica &ndash; citiți cu atenție acești T&amp;C &icirc;nainte de a utiliza serviciile respective.
      </p>
      <p class="justify-content-center ml-3">
         3.3. Utilizatorul va utiliza serviciul MDelivery de o manieră care să nu atenteze, restr&acirc;ngă sau să
         restricționeze drepturile altor utilizatori.
      </p>

      <h6 style="text-decoration: underline" class="w-100">4. Accesarea serviciului MDelivery</h6>
      <p class="justify-content-center ml-3">
         4.1. Serviciul MDelivery poate fi accesat fără sau cu autentificare. Accesarea cu autentificare oferă accesul
         la serviciul MDelivery conform categoriei de utilizator din care faceți parte.
      </p>

      <p class="justify-content-center ml-3">
         4.2. &Icirc;n cazul autentificării pe pagina web dedicată serviciul MDelivery, utilizatorul este responsabil
         pentru păstrarea oricăror informații de autentificare asociate. Prin urmare, utilizatorul este responsabil
         pentru toate activitățile care apar &icirc;n contul său.
      </p>

      <p class="justify-content-center ml-3">4.3. Conturile de utilizator nu sunt transferabile unei alte persoane.</p>

      <p class="justify-content-center ml-3">
         4.4.Utilizatorului nu îi este recomandată transmiterea informațiilor de autentificare oricărei terțe persoane.
         Orice astfel de transmitere este responsabilitatea exclusivă a utilizatorului care își asumă toate consecințele
         asociate.
      </p>

      <p class="justify-content-center ml-3">
         4.5.Pentru accesarea serviciului MDelivery, se recomandă utilizarea ultimelor trei versiuni ale celor mai
         populare browsere (Chrome, Edge, Safari, Firefox). Produsul poate fi accesat atât pe dispozitivele desktop, cât
         și dispozitivele mobile (cu sisteme de operare iOS, Android, Windows).
      </p>

      <h6 style="text-decoration: underline" class="w-100">5. Utilizarea serviciilor asociate serviciului MDelivery</h6>
      <p class="justify-content-center ml-3">
         5.1. Utilizatorul confirmă că îi este permisă utilizarea serviciilor asociate serviciului MDelivery în
         conformitate cu cadrul normativ.
      </p>

      <p class="justify-content-center ml-3">
         5.2.Dacă utilizatorul accesează serviciile asociate serviciului MDelivery din numele unei persoane fizice sau
         juridice, acesta confirmă că are autoritatea legală de a accepta acești T&C din numele acelei persoane, astfel
         încât persoana fizică sau juridică respectivă acceptă acești T&C.
      </p>

      <p class="justify-content-center ml-3">
         5.3.Utilizatorul va urma orice ghid sau politică asociată cu serviciile asociate serviciului MDelivery.
      </p>

      <p class="justify-content-center ml-3">
         5.4.Utilizatorul nu va utiliza serviciile asociate serviciului MDelivery în mod abuziv și nu va interfera cu
         serviciile sau va încerca accesarea lor prin intermediul unei alte metode decât prin interfața și
         instrucțiunile puse la dispoziție de către AGE.
      </p>

      <p class="justify-content-center ml-3">
         5.5.Dacă nu este prevăzut altfel, utilizatorul nu va accesa sau reutiliza serviciile asociate serviciului
         MDelivery sau orice porțiune a sistemului informațional destinat utilizării produsului în scopuri comerciale.
      </p>

      <h6 style="text-decoration: underline" class="w-100">6. Conduita utilizatorului</h6>
      <p class="justify-content-center ml-3">
         6.1. Utilizatorul este de acord să nu interfațeze cu serverele sau rețelele ce au legătură cu serviciile
         asociate serviciului MDelivery și să nu &icirc;ncalce nicio procedură, politică sau regulament ce au legătură
         cu serviciul MDelivery, inclusiv:
      </p>
      <ul>
         <li>să nu pretindă că este altă persoană &icirc;n timp ce folosește serviciului MDelivery;</li>
         <li>
            să obțină sau să &icirc;ncerce să obțină acces neautorizat la serviciile, serverele, rețeaua sau datele
            serviciului MDelivery;
         </li>
         <li>
            să nu &icirc;ncarce conținut care este dăunător copiilor, amenințător, abuziv, de hărțuire, tortură,
            defăimător, calomnios, vulgar, obscen, invaziv, care instigă la ură rasială, etnică sau de alt tip;
         </li>
         <li>
            să nu folosească serviciul MDelivery &icirc;n scopuri ilegale sau prin &icirc;ncălcarea cadrul normativ;
         </li>
         <li>
            să nu facă disponibil orice conținut pentru care nu are permisiunea respectivă sau care afectează orice
            marcă, secret comercial, drept de autor sau alt tip de proprietate intelectuală a oricărei persoane;
         </li>
         <li>
            să nu &icirc;ncarce, posteze, trimită e-mail sau orice alt material ce conține viruși sau alte coduri de
            computer, fișiere sau programe menite să &icirc;ntrerupă, distrugă sau să limiteze funcționalitatea
            serviciului MDelivery sau a oricărui alt software sau hardware sau echipament de telecomunicație asociat
            serviciului MDelivery;
         </li>
         <li>
            să nu utilizeze serviciile asociate serviciului MDelivery &icirc;n scopul obținerii unor avantaje financiare
            sau similare celor financiare, dec&acirc;t dacă are acordul AGE &icirc;n acest sens.
         </li>
      </ul>
      <h6 style="text-decoration: underline" class="w-100">
         7. Utilizarea serviciului MDelivery și costurile de livrare
      </h6>
      <p class="justify-content-center ml-3">
         7.1. Accesul la serviciul MDelivery și funcționalitățile acestuia este gratuit.
      </p>

      <p class="justify-content-center ml-3">
         7.2. Costurile pentru serviciile de livrare se achită de către utilizatorul serviciului MDelivery în
         conformitate cu costurile stabilite și comunicate automatizat de către furnizorul de servicii poștale.
      </p>

      <p class="justify-content-center ml-3">
         7.3. Achitarea costurilor de livrare se efectuează prin intermediul serviciului guvernamental de plăți
         electronice MPay. În cazul utilizării serviciului guvernamental de plăți electronice (MPay) pentru achitarea
         serviciilor, se aplică T&C serviciului MPay, care pot fi citiți la adresa
         <a href="https://mpay.gov.md/Info/TermsAndConditions" target="_blank"
            >https://mpay.gov.md/Info/TermsAndConditions</a
         >.
      </p>

      <h6 style="text-decoration: underline" class="w-100">8. Datele de livrare</h6>
      <p class="justify-content-center ml-3">
         8.1. Utilizatorul este responsabil pentru indicarea datelor complete și exacte pentru livrarea trimiterii.
         Detaliile adresei trebuie să se încadreze în interfața destinată completării acesteia și să fie înserate toate
         datele marcate ca obligatoriu de completat.
      </p>

      <p class="justify-content-center ml-3">
         8.2. Utilizatorul este de acord, că odată cu furnizarea adresei de e-mail la completarea detaliilor de livrare,
         va primi notificări cu privire la etapa livrării trimiterii.
      </p>

      <p class="justify-content-center ml-3">
         8.3. În cazul în care, furnizorul de servicii poștale nu oferă livrarea la adresa indicată, selectarea acestui
         furnizor va fi indisponibilă. Totodată, în cazul în care nici un furnizor de servicii poștale nu oferă livrarea
         la adresa indicată, livrarea prin intermediul Serviciului MDelivery va fi indisponibilă.
      </p>

      <h6 style="text-decoration: underline" class="w-100">9. Confirmarea și anularea comenzii</h6>
      <p class="justify-content-center ml-3">
         9.1. Odată ce comanda de livrare este plasată și achitată, utilizatorul va primi un e-mail de confirmare
         privind acceptarea acesteia cu indicarea unui număr de urmărire, prin care va putea monitoriza etapele de
         livrare.
      </p>

      <p class="justify-content-center ml-3">
         9.2. Comanda de livrare, poate fi anulată de către utilizator doar în cazul în care este anulată prestarea
         serviciului public pentru care a fost solicitată livrarea iar comanda de livrare nu a fost ridicată de către
         furnizorul de servicii poștale.
      </p>

      <p class="justify-content-center ml-3">
         9.3. În cazul anulării comenzii de livrare, restituirea mijloacelor financiare se efectuează de către
         furnizorul de servicii poștale care a primit comanda de livrare, prin depunerea unei cereri în adresa acestuia
         de către utilizator. Datele furnizorului de servicii poștale pot fi vizualizate în nota de plată a comenzii de
         livrare. Procesul de restituire a mijloacelor financiare are loc în afara serviciului guvernamental de plăți
         electronice (MPay).
      </p>

      <h6 style="text-decoration: underline" class="w-100">10. Condiții de livrare</h6>
      <p class="justify-content-center ml-3">
         10.1. Trimiterea se livrează la adresa indicată de către destinatar, personal către destinatar sau către
         persoana împuternicită legal să primească trimiterea poștală. Stabilirea identității destinatarului trimiterii
         poștale, se va face în condițiile cadrului legal din țara destinatarului. Trimiterea poștală nu poate fi
         livrată la căsuța poștală
      </p>

      <p class="justify-content-center ml-3">
         10.2. Utilizatorul nu poate modifica adresa de livrare din moment ce comanda a fost plasată și achitată.
      </p>

      <p class="justify-content-center ml-3">
         10.3 Trimiterea poștală nelivrată din motive, precum: refuzarea primirii, adresă incompletă, destinatarul nu a
         fost găsit la adresa indicată și alte motive neimputate furnizorului de servicii poștale, se va păstra în
         cadrul oficiilor furnizorilor de servicii poștale, iar după expirarea termenului de păstrare se va returna
         expeditorului
      </p>

      <h6 style="text-decoration: underline" class="w-100">
         11. Responsabilitatea pentru prestarea serviciului de livrare
      </h6>
      <p class="justify-content-center ml-3">
         11.1. Serviciul MDelivery nu poartă răspundere materială pentru pierderea, furtul, distrugerea sau deteriorarea
         trimiterii poștale. Răspunderea materială în cazul dat o poartă furnizorii de servicii poștale dacă aceste
         împrejurări au survenit după momentul ridicării trimiterii de la expeditor și până la momentul livrării la
         destinatar.
      </p>

      <p class="justify-content-center ml-3">
         11.2. Orice reclamație referitor la livrările efectuate prin intermediul serviciului MDelivery, pot fi adresate
         către serviciul suport MDelivery sau direct furnizorului de servicii poștale, cu însoțirea notei de plată
         aferentă comenzii de livrare.
      </p>

      <p class="justify-content-center ml-3">
         11.3. Termenii de livrare în cadrul serviciului MDelivery sunt estimativi și sunt furnizați de către furnizorul
         de servicii poștale selectat.
      </p>

      <h6 style="text-decoration: underline" class="w-100">12. Disponibilitatea serviciului MDelivery</h6>
      <p class="justify-content-center ml-3">
         12.1. Serviciul MDelivery este disponibil 7 zile pe săptămână, cu program continuu. Perioada garantată pentru
         nivelul agreat de disponibilitate a serviciilor este de 24 ore pe zi. Timpul acesta nu include perioada alocată
         lucrărilor de mentenanță care vor fi efectuate de regulă în afara orelor de muncă cu excepția cazurilor de
         urgență sau imprevizibile.
      </p>

      <p class="justify-content-center ml-3">
         12.2. Disponibilitatea serviciului MDelivery nu presupune și disponibilitatea livrării de către furnizorii de
         servicii poștale în termenii de la pct.12.1
      </p>

      <p class="justify-content-center ml-3">
         12.3. Dacă serviciul MDelivery este indisponibil, rugăm să contactați Serviciul suport clienți.
      </p>

      <p class="justify-content-center ml-3">
         12.4. Prin utilizarea serviciului MDelivery, utilizatorul înțelege și este de acord că toate resursele pe care
         le furnizează AGE sunt „așa cum sunt” și „așa cum sunt disponibile”. Aceasta înseamnă că AGE nu garantează că:
         <br />
         - utilizarea resurselor serviciului MDelivery va satisface toate nevoile sau cerințele utilizatorului; <br />
         - utilizarea serviciilor asociate serviciului MDelivery va fi neîntreruptă, în timp util, sigură sau fără
         erori.
      </p>

      <h6 style="text-decoration: underline" class="w-100">13. Modificarea și încetarea serviciilor și a contului</h6>
      <p class="justify-content-center ml-3">
         13.1. AGE constant inovează, schimbă și îmbunătățește serviciile asociate serviciului MDelivery. Astfel, este
         posibilă, fără notificarea utilizatorului, adăugarea sau eliminarea unor funcționalități sau caracteristici,
         crearea de noi limite ale serviciilor sau suspendarea ori stoparea permanentă a serviciilor asociate
         serviciului MDelivery.
      </p>
      <p class="justify-content-center ml-3">
         13.2. Utilizatorul poate oricând să stopeze utilizarea serviciilor asociate serviciului MDelivery.
      </p>
      <p class="justify-content-center ml-3">
         13.3. AGE poate temporar să suspende sau să anuleze orice cont, fără notificare, inclusiv, dar nu doar, în
         cazul violării T&C.
      </p>

      <h6 style="text-decoration: underline" class="w-100">14. Modificările T&C</h6>
      <p class="justify-content-center ml-3">
         14.1. AGE își rezervă dreptul de a modifica T&C, iar versiunea actualizată va fi publicată pe interfața de
         acces a utilizatorilor la sistemele informaționale destinate utilizării serviciului MDelivery (paginile web
         dedicate). Este responsabilitatea utilizatorului de a citi T&C înainte de a utiliza serviciul MDelivery.
      </p>

      <h6 style="text-decoration: underline" class="w-100">15. Suport și asistență</h6>
      <p class="justify-content-center ml-3">
         15.1. Pentru asistență, sugestii sau depunerea unui petiții, vă rugăm să contactați Serviciul suport clienți
         prin următoarele canale: <br />
         Tel: (+373) (22) 82 00 03; <br />
         Email: <a href="suport.mdelivery@egov.md" target="_blank">suport.mdelivery@egov.md</a>
      </p>
      <p class="justify-content-center ml-3">
         15.2. În cazul solicitărilor expediate pe email, echipa de suport a serviciului MDelivery va depune tot efortul
         pentru a oferi răspunsuri în termen de cel mult 7 zile lucrătoare. În cazul în care nu primiți un răspuns în
         acest termen, cel mai probabil operatorii noștri sunt supraîncărcați, și ca urmare vă rugăm să reveniți cu un
         mesaj repetat dacă chestiunea Dvs. nu suferă amânare iar echipa noastră va reprioritiza cererea Dvs.
      </p>
      <p class="justify-content-center ml-3">
         15.3. Pentru a beneficia de suport în cazul unei deficiențe sau probleme apărute, recomandăm: <br />
         - sesizarea echipei de management a serviciului MDelivery în cel mult 180 zile de la depistarea
         incidentului/problemei; <br />
         - expedierea tuturor actelor/documentelor solicitate ulterior de echipa de suport a serviciului MDelivery.
      </p>

      <h6 style="text-decoration: underline" class="w-100">16. Feedback</h6>
      <p class="justify-content-center ml-3">
         16.1. Utilizatorul consimte că orice recomandare, idee, propunere, sugestie sau feedback (denumite generic
         „Feedback”) transmis către AGE cu referire la produse, servicii, website-uri, aplicații sau tehnologii poate fi
         utilizată de către AGE fără notificare, obligație, restricție, compensare sau rambursare către utilizator și
         acesta renunță la orice drept care există sau ar putea să existe în viitor în orice feedback.
      </p>

      <h6 style="text-decoration: underline" class="w-100">17. Confidențialitatea datelor cu caracter personal</h6>
      <p class="justify-content-center ml-3">
         17.1. Angajamentul AGE este de a pune utilizatorul în prim-plan. În acest sens, AGE depune toată străduința
         pentru a asigura transparența în privința modului în care colectează și utilizează informațiile cu caracter
         personal, precum și privind păstrarea acestor informații.
      </p>

      <p class="justify-content-center ml-3">
         17.2. Accesarea serviciului MDelivery va fi tratată ca acordare a consimțământului de a procesa, prelucra și
         stoca datele cu caracter personal în conformitate cu cadrul normativ aferent protecției datelor cu caracter
         personal în scopul formalizării unei comenzi de livrare și poate fi contestată în modul stabilit de legislație.
      </p>

      <p class="justify-content-center ml-3">
         17.3. Datele cu caracter personal ale utilizatorului includ toate sau una din următoarele categorii:
         nume/prenume, e-mail, telefon, semnătura electronică, adresa, IDNP. Scopul prelucrării informațiilor ce conțin
         date cu caracter personal de către serviciul MDelivery este gestiunea administrativă a procesului de livrare a
         rezultatelor serviciilor publice și altor livrabile în limita cadrului normativ.
      </p>

      <p class="justify-content-center ml-3">
         17.4. Informația cu caracter personal este confidențială și nu este transmisă altor terți, inclusiv nici în
         scopuri de marketing sau de generare de venituri din utilizarea de date personale, decât dacă deținătorul
         acestor date își dă consimțământul în acest sens sau la solicitarea, conform cadrul normativ, din partea
         organelor de drept.
      </p>

      <p class="justify-content-center ml-3">
         17.5. AGE garantează respectarea drepturilor titularilor datelor cu caracter personal prevăzut de cadrul
         normativ aferent protecției datelor cu caracter personal, luând toate măsurile pentru a proteja aceste date
         contra accesului neautorizat, utilizarea sau divulgarea lor.
      </p>

      <h6 style="text-decoration: underline" class="w-100">18. Drepturile de proprietate intelectuală</h6>
      <p class="justify-content-center ml-3">
         18.1. Conținutul și materialele disponibile în Produs, definite ca text, imagini, grafică se oferă ca și
         conținut sub licența CCBY 4.0 (<a href="https://creativecommons.org/licenses/by/4.0/" target="_blank"
            >https://creativecommons.org/licenses/by/4.0/</a
         >) dacă nu sunt expres marcate ca informație protejată de drepturile de autor.
      </p>

      <p class="justify-content-center ml-3">
         18.2. Numele de site, codul sursă, marca și logo-urile sunt proprietatea intelectuală a AGE și sunt protejate
         de legislația privind drepturile de autor și mărcile comerciale aplicabile. Orice utilizare inadecvată,
         inclusiv, dar fără a se limita la reproducerea, distribuirea, afișarea sau transmiterea acestora este
         restricționată dacă nu este autorizată în mod expres de AGE, cu excepția cazului în care este utilizat de către
         jurnaliști și în scopuri de promovare a Produsului sau în scopuri academice.
      </p>

      <p class="justify-content-center ml-3">
         18.3. AGE respectă dreptul la proprietate intelectuală a celorlalți și așteaptă ca utilizatorii să aibă o
         conduită asemănătoare. AGE poate, în circumstanțe adecvate și la propria discreție, să anuleze sau să
         întreprindă alți pași cu privire la conturile de utilizator care încalcă dreptul la proprietate intelectuală.
         Dacă considerați că dreptul dvs. la proprietate intelectuală a fost încălcat, vă rugăm să contactați Serviciul
         suport clienți și să transmiteți o notificare cu următoarele informații: <br />
         - informații privind materialul pentru care considerați că a fost încălcat dreptul la proprietate intelectuală.
         Dacă acest material există online, transmiteți un URL, sau oferiți detalii pertinente pentru a fi identificat;
         <br />
         - informația de contact, inclusiv numele, adresa, numărul de telefon și adresa de e-mail la care vă putem
         contacta; <br />
         - o confirmare din partea dvs. că informația transmisă este veridică și că în conformitate cu cadrul normativ,
         sunteți deținătorul drepturilor sau autorizat să reprezentați interesele deținătorului drepturilor respective;
         <br />
         - semnătura dvs. electronică sau fizică.
      </p>

      <h6 style="text-decoration: underline" class="w-100">Datele posesorului serviciului MDelivery</h6>
      <p>
         <strong>Posesor: Instituția Publică „Agenția de Guvernare Electronică”</strong> <br />
         <strong>IDNO : 1010600034203</strong> <br />
         <strong>Adresa : mun. Chișinău, bd. Ștefan cel Mare și Sfânt, 134, MD-2012.</strong>
      </p>
      <br />
   </div>
</div>
